import { frontendURL } from 'dashboard/helper/URLHelper';
import SkyProductsView from './SkyProductsView.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/sky-products'),
    name: 'sky_products_view',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: SkyProductsView,
  },
];
